import { Dayjs } from 'dayjs';

export type AnalyticsFiltersType = {
  dates?: [Dayjs, Dayjs];
  utm_campaign?: string;
  utm_medium?: string;
  utm_term?: string;
};

export enum AnalyticsTabsEnum {
  review = 'review',
  dynamics = 'dynamics'
}
